import React from 'react'
import AddNewIssuedCheckProvider from './index.provider'
import AddNewIssuedCheckContent from './index.content'

const AddNewIssuedCheckScreen: React.FC = () => {
  return (
    <AddNewIssuedCheckProvider>
      <AddNewIssuedCheckContent />
    </AddNewIssuedCheckProvider>
  )
}

export default AddNewIssuedCheckScreen
